import React from "react";
import type {
  QualificationItem,
  QualificationDraft,
} from "../../../../api/qualification/Qualification.typed";
import DarkTypography from "../../../common/DarkTypography";
import DarkInput from "../../../common/DarkInput";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { SEdit, SDelete, SSave, SClose } from "../../../../styles/StyledMUI";

export type QualificationItemRowProps = {
  item: QualificationItem;
  isEditing: boolean;
  draft: QualificationDraft;
  canEdit: boolean;
  loading: boolean;
  onDraftChange: (patch: Partial<QualificationDraft>) => void;
  onSave: () => void;
  onCancel: () => void;
  onEdit: () => void;
  onRemove: () => void;
};

export default function QualificationItemRow({
  item,
  isEditing,
  draft,
  canEdit,
  loading,
  onDraftChange,
  onSave,
  onCancel,
  onEdit,
  onRemove,
}: QualificationItemRowProps) {
  return (
    <tr>
      <td>
        {isEditing ? (
          <DarkInput
            value={draft.sigle}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onDraftChange({ sigle: e.target.value })
            }
            size="sm"
          />
        ) : (
          <DarkTypography level="body-sm">{item.sigle}</DarkTypography>
        )}
      </td>
      <td>
        {isEditing ? (
          <DarkInput
            value={draft.name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onDraftChange({ name: e.target.value })
            }
            size="sm"
          />
        ) : (
          <DarkTypography level="body-sm">{item.name ?? "—"}</DarkTypography>
        )}
      </td>
      <td>
        {isEditing ? (
          <DarkInput
            value={draft.description}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onDraftChange({ description: e.target.value })
            }
            size="sm"
          />
        ) : (
          <DarkTypography level="body-sm">{item.description ?? "—"}</DarkTypography>
        )}
      </td>
      {canEdit && (
        <td>
          {isEditing ? (
            <>
              <IconButtonCTA
                aria-label="Enregistrer"
                ctaVariant="success"
                onClick={onSave}
                disabled={loading || !draft.sigle.trim()}
                sx={{ mr: 1 }}
              >
                <SSave />
              </IconButtonCTA>
              <IconButtonCTA
                aria-label="Annuler"
                ctaVariant="neutral"
                onClick={onCancel}
                disabled={loading}
              >
                <SClose />
              </IconButtonCTA>
            </>
          ) : (
            <>
              <IconButtonCTA
                aria-label="Modifier la qualification"
                ctaVariant="accent"
                onClick={onEdit}
                disabled={loading}
                sx={{ mr: 1 }}
              >
                <SEdit />
              </IconButtonCTA>
              <IconButtonCTA
                aria-label="Supprimer la qualification"
                ctaVariant="danger"
                onClick={onRemove}
                disabled={loading}
              >
                <SDelete />
              </IconButtonCTA>
            </>
          )}
        </td>
      )}
    </tr>
  );
}
